<template>
  <div>
    <div style="display:flex;align-items:center;border-bottom:1px solid #eee;margin-bottom:12px;">
      <div
        v-for="tab in tabs"
        :key="tab.key"
        class="tab-item"
        :class="{ active: activeTab === tab.key }"
        @click="handleTabChange(tab.key)"
      >
        <span style="font-weight:500;">{{ tab.label }}</span>
        <Poptip
          v-if="tab.tip"
          trigger="hover"
          transfer
          placement="top"
          :content="tab.tip"
        >
          <Icon type="md-help-circle" style="margin-left:4px;color:#999;font-size:14px;"></Icon>
        </Poptip>
      </div>
    </div>
    <div v-if="activeTab === 'all'" class="search-form">
      <Input
        type="number"
        v-model="searchForm.playId"
        placeholder="请输入短剧ID"
        style="width: 180px;"
        clearable
      />
      <Input
        v-model="searchForm.chineseName"
        placeholder="请输入中文剧名"
        style="width: 220px;"
        clearable
      />
      <Input
        v-model="searchForm.playName"
        placeholder="请输入剧名（外语）"
        style="width: 220px;"
        clearable
      />
      <Select
        v-model="searchForm.tagIds"
        placeholder="请选择标签"
        style="width: 200px"
        multiple
        filterable
        :max-tag-count="2"
      >
        <Option
          v-for="(item, index) in tagList"
          :key="index"
          :value="item.id"
          >{{ item.tagChineseName || item.tagName }}</Option
        >
      </Select>
      <Select
        v-if="showLang"
        v-model="searchForm.langId"
        placeholder="请选择语言"
        style="width: 220px"
      >
        <Option
          v-for="(item, index) in langList"
          :key="index"
          :value="item.id"
          >{{ item.chineseLangName }}</Option
        >
      </Select>
      <Button @click="handleSearch" type="primary">查询</Button>
      <Button @click="handleReset">重置</Button>
    </div>
    <div ref="scrollContainer" class="scroll-wrapper" style="max-height:440px;overflow-y:auto;border:1px solid #dcdee2;">
      <Table
        ref="tableRef"
        row-key="playId"
        :data="tableData"
        :columns="columns"
        :loading="loading"
        :row-class-name="addRowClassName"
        @on-select="handleTableSelect"
        @on-select-cancel="handleTableSelectCancel"
        @on-select-all="handleTableSelectAll"
        @on-select-all-cancel="handleTableSelectAllCancel"
      >
        <template #rankIndex="{ row, index }">
        <div style="text-align:center;font-weight:600;">
          {{ row.playSort != null && row.playSort !== '' ? row.playSort : (index + 1) }}
        </div>
      </template>
        <template #playInfo="{row}">
          <div style="display:flex;align-items:center;gap:14px;">
            <div style="flex-shrink:0;width:84px;height:112px;border-radius:4px;overflow:hidden;background:#f0f0f0;">
              <img
                v-if="row.fileUrl"
                :src="row.fileUrl"
                style="width:100%;height:100%;object-fit:cover;cursor:pointer;"
                @click="$viewerApi({images:[row.fileUrl]})"
              />
            </div>
            <div style="flex:1;min-width:0;display:flex;flex-direction:column;gap:6px;">
              <div style="font-size:14px;font-weight:600;color:#222;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ row.playName || '-' }}</div>
              <div style="font-size:12px;color:#999;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ row.chinesePlayName || '-' }}</div>
              <Tag
                v-if="isRowDisabled(row)"
                color="green"
                style="align-self:flex-start;font-size:12px;height:22px;line-height:20px;padding:0 8px;"
              >已添加</Tag>
            </div>
          </div>
        </template>
        <template #tagNames="{row}">
          <div style="display:flex;flex-wrap:wrap;gap:4px;align-items:center;">
            <Tag
              v-for="(tag, idx) in (row.tagNames || []).slice(0,3)"
              :key="idx"
              color="blue"
              style="font-size:12px;height:22px;line-height:20px;padding:0 8px;"
            >{{ tag }}</Tag>
            <Poptip
              v-if="(row.tagNames || []).length > 3"
              trigger="hover"
              transfer
              placement="top"
            >
              <Tag color="default" style="font-size:12px;height:22px;line-height:20px;padding:0 8px;">+{{ (row.tagNames || []).length - 3 }}</Tag>
              <template #content>
                <div style="max-width:240px;">
                  <div v-for="(tag, idx) in row.tagNames" :key="idx" style="margin:4px 0;">
                    {{ tag }}
                  </div>
                </div>
              </template>
            </Poptip>
          </div>
        </template>
        <template #footer>
          <div style="text-align:center;color:#999;font-size:13px;padding:6px 0;">
            <span>共 {{ tableData.length }} 条</span>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { getLangList } from '../../../api/lang'
import { getTheaterPlayTop100 } from '../../../api/theater'
import { getTagList } from '../../../api/tag'

export default {
  components: {},
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    query: {
      type: Object,
      default: () => ({})
    },
    showLang: {
      type: Boolean,
      default: false
    },
    selectedData: {
      type: Array,
      default: () => []
    },
    func: {
      type: Function,
      default: () => ({})
    }
  },
  data() {
    return {
      activeTab: 'all',
      searchForm: {},
      tableData: [],
      langList: [],
      tagList: [],
      selection: [],
      loading: false
    }
  },
  computed: {
    isReservationStyle() {
      return Number(this.form.theaterStyle) === 20
    },
    tabs() {
      const tabs = [{ key: 'all', label: '全部短剧' }]
      if (!this.isReservationStyle) {
        tabs.push({ key: 'top100', label: 'TOP 100剧', tip: '每周更新一次数据' })
      }
      return tabs
    },
    columns() {
      if (this.activeTab === 'top100') {
        return [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '排名',
            width: 80,
            slot: 'rankIndex',
            align: 'center'
          },
          {
            title: '短剧ID',
            key: 'playId',
            width: 100
          },
          {
            title: '短剧信息',
            slot: 'playInfo',
            minWidth: 360
          },
          {
            title: '标签',
            slot: 'tagNames',
            minWidth: 180
          }
        ]
      }
      return [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '短剧id',
          key: 'playId',
          width: 100
        },
        {
          title: '短剧信息',
          slot: 'playInfo',
          minWidth: 360
        },
        {
          title: '标签',
          slot: 'tagNames',
          minWidth: 180
        }
      ]
    }
  },
  methods: {
    normalizeId(value) {
      return value === undefined || value === null ? '' : String(value)
    },
    isRowDisabled(row) {
      if (!row) return false
      const rowId = this.normalizeId(row.playId)
      return (this.selectedData || []).some(id => this.normalizeId(id) === rowId)
    },
    addRowClassName(row) {
      return this.isRowDisabled(row) ? 'disabled-row' : ''
    },
    handleTableSelect(selection, row) {
      if (this.isRowDisabled(row)) return
      const exist = (this.selection || []).findIndex(i => i.playId === row.playId)
      if (exist < 0) {
        this.selection = [...(this.selection || []), row]
      }
      this.$emit('update:selectedCount', this.selection.length)
    },
    handleTableSelectCancel(selection, row) {
      this.selection = (this.selection || []).filter(s => s.playId !== row.playId)
      this.$emit('update:selectedCount', this.selection.length)
    },
    handleTableSelectAll(selection) {
      const allRows = (this.tableData || [])
      const selectableRows = allRows.filter(r => !this.isRowDisabled(r))
      const currentPagePlayIds = new Set(selectableRows.map(r => r.playId))
      const otherSelected = (this.selection || []).filter(s => !currentPagePlayIds.has(s.playId))
      const merged = [...otherSelected, ...selectableRows]
      const uniqMap = {}
      const uniqArr = []
      merged.forEach(m => {
        const key = String(m.playId)
        if (!uniqMap[key]) {
          uniqMap[key] = true
          uniqArr.push(m)
        }
      })
      this.selection = uniqArr
      this.$emit('update:selectedCount', this.selection.length)
    },
    handleTableSelectAllCancel() {
      const selectableRows = (this.tableData || []).filter(r => !this.isRowDisabled(r))
      const currentPagePlayIds = new Set(selectableRows.map(r => r.playId))
      this.selection = (this.selection || []).filter(s => !currentPagePlayIds.has(s.playId))
      this.$emit('update:selectedCount', this.selection.length)
    },
    handleTabChange(key) {
      if (this.activeTab === key) return
      this.activeTab = key
      this.getData(true)
    },
    handleSearch() {
      this.getData(true)
    },
    handleReset() {
      this.searchForm = {
        langId: this.searchForm.langId,
        playId: '',
        chineseName: '',
        playName: '',
        tagIds: []
      }
      this.getData(true)
    },
    handleGetLang() {
      var self = this
      getLangList({
        current: -1,
        size: -1
      }).then(function (r) {
        self.langList = (r && r.data && r.data.records) || []
        self.$nextTick(function () {
          var queryLang = self.query && self.query.langId
          var formLang = self.form && self.form.langId
          var prefer = (queryLang !== undefined && queryLang !== null) ? queryLang : formLang
          var alreadyHas = self.searchForm && self.searchForm.langId !== undefined && self.searchForm.langId !== null && self.searchForm.langId !== ''
          if (!alreadyHas && prefer) {
            self.searchForm = Object.assign({}, self.searchForm, { langId: prefer })
          } else if (!alreadyHas && self.langList.length) {
            self.searchForm = Object.assign({}, self.searchForm, { langId: self.langList[0].id })
          }
        })
      })
    },
    handleGetTag() {
      var self = this
      getTagList({
        current: -1,
        size: -1
      }).then(function (r) {
        self.tagList = (r && r.data && r.data.records) || []
      })
    },
    requestData() {
      if (this.activeTab === 'top100') {
        const queryLang = this.query && this.query.langId
        const formLang = this.form && this.form.langId
        const langId = (queryLang !== undefined && queryLang !== null) ? queryLang : formLang
        const extraParams = Object.assign({}, this.query, {
          langId: langId
        })
        return getTheaterPlayTop100({
          langId: langId,
          theaterId: extraParams.theaterId
        })
      }
      const queryLang = this.query && this.query.langId
      const formLang = this.form && this.form.langId
      const searchLang = this.searchForm && this.searchForm.langId
      const langId = (searchLang !== undefined && searchLang !== null && searchLang !== '')
        ? searchLang
        : ((queryLang !== undefined && queryLang !== null) ? queryLang : formLang)
      const params = {
        current: -1,
        size: -1,
        theaterId: this.query.theaterId,
        langId: langId,
        playId: this.searchForm.playId || undefined,
        chineseName: this.searchForm.chineseName || undefined,
        playName: this.searchForm.playName || undefined,
        tagIds: (this.searchForm.tagIds && this.searchForm.tagIds.length) ? this.searchForm.tagIds.join(',') : undefined
      }
      return this.func(params)
    },
    getData(reset = true) {
      this.loading = true
      var self = this
      this.requestData().then(function (res) {
        var data = res && res.data
        var records = []
        if (Array.isArray(data)) {
          records = data
        } else if (data) {
          records = data.records || []
        }
        if (self.activeTab === 'all') {
          records = records.slice().reverse()
        }
        self.tableData = records.map(row => ({
          ...row,
          _disabled: self.isRowDisabled(row)
        }))
        self.loading = false
      }).catch(function () {
        self.loading = false
      })
    },
    getSelection(data) {
      this.selection = data || []
      this.$emit('update:selectedCount', this.selection.length)
    }
  },
  watch: {
    tableData() {
      this.$nextTick(() => {
        const table = this.$refs.tableRef
        if (!table || !table.objData) return
        const selectedIdSet = {}
        ;(this.selection || []).forEach(item => {
          selectedIdSet[String(item.playId)] = true
        })
        ;(this.tableData || []).forEach((row, index) => {
          const objRow = table.objData[index]
          if (objRow && selectedIdSet[String(row.playId)]) {
            objRow._isChecked = true
          }
        })
      })
    }
  },
  mounted() {
    this.getData(true)
    this.handleGetLang()
    this.handleGetTag()
  },
  beforeDestroy() {
  }
}
</script>

<style lang="less" scoped>
.search-form {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  & > * {
    margin: 0 5px;
  }
}

.tab-item {
  position: relative;
  padding: 12px 20px;
  cursor: pointer;
  font-size: 14px;
  color: #515a6e;
  margin-right: 4px;
  display: flex;
  align-items: center;

  &.active {
    color: #2d8cf0;
    &::after {
      content: '';
      position: absolute;
      left: 12px;
      right: 12px;
      bottom: -1px;
      height: 2px;
      background: #2d8cf0;
      border-radius: 2px;
    }
  }
  &:hover:not(.active) {
    color: #2d8cf0;
  }
}

/deep/ .disabled-row td {
  color: #bbbec4 !important;
  background: #f8f8f9 !important;
}
/deep/ .disabled-row .ivu-checkbox-wrapper {
  cursor: not-allowed !important;
  .ivu-checkbox {
    background: #f2f2f2 !important;
    .ivu-checkbox-inner {
      background-color: #f2f2f2 !important;
      border-color: #dcdee2 !important;
    }
  }
}
</style>
